"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralPoolsProgram = exports.AccountType = void 0;
const web3_js_1 = require("@solana/web3.js");
const common_1 = require("@everlend/common");
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["PoolMarket"] = 1] = "PoolMarket";
    AccountType[AccountType["Pool"] = 2] = "Pool";
    AccountType[AccountType["PoolBorrowAuthority"] = 3] = "PoolBorrowAuthority";
    AccountType[AccountType["WithdrawRequests"] = 4] = "WithdrawRequests";
    AccountType[AccountType["WithdrawRequest"] = 5] = "WithdrawRequest";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
class GeneralPoolsProgram extends common_1.Program {
}
exports.GeneralPoolsProgram = GeneralPoolsProgram;
GeneralPoolsProgram.PUBKEY = new web3_js_1.PublicKey('GenUMNGcWca1GiPLfg89698Gfys1dzk9BAGsyb9aEL2u');
//# sourceMappingURL=program.js.map